import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  addVwoDecision,
  addPayFrequencyLookup,
  addCheckoutAll,
  changeFeatureLinearFlow,
  addVerificationCheckoutUid,
  sendError,
} from '../redux/actions';
import useShopifyApi from '../hooks/useShopifyApi';
import SubmitButton from '../components/SubmitButton';
import CheckCircle from '../assets/img/check-circle.png';

// eslint-disable-next-line no-shadow
function NewUserApproved() {
  const store = useSelector(state => ({
    newUserDetails: state.personal?.newUserDetails,
    checkoutLookupData: state.personal?.checkoutLookupData,
    phone: state.contact?.phone,
    featureGates: state.technical?.featureGates,
    DEdgeToken: state.technical?.DEdgeToken,
    verificationCode: state.loanInfo?.verificationCode,
    isInstoreVccFlow: state.technical?.instoreVccFlow?.isInstoreVccFlow,
  }));
  const { handleSubmit } = useForm();
  const { request, response, loading } = useShopifyApi();
  const history = useHistory();
  const dispatch = useDispatch();
  const onSubmit = async () => {
    // In-store VCC has no cart yet: the shopper builds it next, so skip Shopify's cart_check / initialize.
    if (store.isInstoreVccFlow) {
      history.push('/approved-with-cart');
      return;
    }
    const payload = {
      ...store.checkoutLookupData?.checkout_object,
      phone: store.phone,
    };

    const cartCheck = await request?.cartCheck(payload);
    if (cartCheck?.is_valid === false) {
      const exceededBy = parseFloat(cartCheck.cart_total - cartCheck.available_limit, 10).toFixed(2);
      const message = `Shopping cart exceeds available limit by $${exceededBy}.
      Please remove an item(s) in order to proceed to checkout.`;
      dispatch(sendError({ message }));
      dispatch(addCheckoutAll(cartCheck));
      if (store.featureGates?.EnableDownpayment) {
        history.push('/exceeded-limit-lcr');
      } else {
        history.push('/exceeded-limit');
      }
    } else if (cartCheck?.downpayment) {
      const exceededBy = parseFloat(cartCheck.cart_total - cartCheck.available_limit, 10).toFixed(2);
      const message = `You have exceeded your available limit by $${exceededBy}`;
      dispatch(sendError({ message }));
      dispatch(addCheckoutAll(cartCheck));
      if (store.featureGates?.EnableDownpayment) {
        history.push('/exceeded-limit-lcr');
      } else {
        history.push('/exceeded-limit');
      }
    } else {
      const initPayload = { ...payload, dedge_token: store.DEdgeToken, code: store.verificationCode };
      await request.initializeRequest(initPayload);
      const data = await response?.json();
      if (response.ok) {
        dispatch(addCheckoutAll(data));
        dispatch(
          addPayFrequencyLookup({
            first_name: store.checkoutLookupData?.checkout_object?.customer?.billing?.first_name,
          }),
        );
        dispatch(
          addVwoDecision({
            feature: 'offerPage',
            variation: 'Version-B',
          }),
        );
        dispatch(
          addVwoDecision({
            feature: 'checkoutPage',
            variation: 'Version-A',
          }),
        );
        dispatch(changeFeatureLinearFlow(false));
        dispatch(addVerificationCheckoutUid(data.uid));
        const isIndiana = store.checkoutLookupData?.checkout_object?.customer?.billing?.state === 'Indiana';
        if (isIndiana && data.warranty_names?.length) {
          history.push('/warranty-agreement');
        } else {
          history.push('/display-offered-lease-details');
        }
      } else if (data?.message?.includes('Shopping cart exceeds available limit')) {
        dispatch(sendError(data));
        history.push('/exceeded-limit');
      } else {
        history.push('/error');
      }
    }
  };

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <div className="k-error-image-wrapper">
          <img width="150" height="150" className="congratulation-icon" src={CheckCircle} alt="" />
        </div>
        <h1 className="congratulation-header">Congratulations {store.newUserDetails?.billing_first_name}!</h1>
        <h3 className="congratulation-text k-new-user-approved-text">
          You are pre-approved to lease items with a cash price up to
        </h3>
        <h1 className="congratulation-amount k-new-user-approved-amount">${store.newUserDetails?.available_limit}</h1>
        <div className="k-submit k-new-user-approved-button">
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <SubmitButton text={store.isInstoreVccFlow ? 'Build My Cart' : 'Checkout Now'} loading={loading} />
          </form>
        </div>
      </section>
    </div>
  );
}

export default NewUserApproved;
